import { render, staticRenderFns } from "./GrupoFormComponent.vue?vue&type=template&id=2cfcede7&"
import script from "./GrupoFormComponent.vue?vue&type=script&lang=js&"
export * from "./GrupoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports